var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('one-or-many-sites-field',{attrs:{"handle":_vm.handle,"value":_vm.value,"state":_vm.$store.state.publish[this.storeName],"column-header":_vm.__('Route')},on:{"input":_vm.update}})}
var staticRenderFns = []

export { render, staticRenderFns }